import React, { useState, useEffect } from "react";

import ThreeCanavas from "./blocks/ThreeCanavas";

import { useNavigate } from "react-router-dom";

export default function GamePageMain() {
  const navigate = useNavigate();

  const handleClick = () => {
    // props.history.push('/game');
    navigate(process.env.PUBLIC_URL + "/");
  };

  return (
    <div className="page">
      <ThreeCanavas />
    </div>
  );
}
